import { getInitials } from "../../utils";
import { UserService } from "../../services";

import Settings from "./user-settings";

function resetState() {
  return {
    user_id: "",
    side: "",
    name: "",
    position: "",
    email: "",
    phone: "",
    avatar_url: "",
    count_notify: 0,
    feed: {},
  };
}

export default {
  namespaced: true,

  state: resetState(),

  getters: {
    getUserId(state) {
      return state.user_id;
    },

    getName(state) {
      return state.name;
    },

    getPosition(state) {
      return state.position;
    },

    getEmail(state) {
      return state.email;
    },

    getPhone(state) {
      return state.phone;
    },

    getAvatarURL(state) {
      return state.avatar_url;
    },

    getFeed(state) {
      return state.feed;
    },

    getCountNotify(state) {
      return state.count_notify;
    },

    getInitials(state, getters) {
      return getInitials(getters["getName"]);
    },

    buildAuthorForMessage(state) {
      return {
        type: "user",
        id: state.user_id,
        name: state.name,
      };
    },
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },

    SET_USER_ID(state, userId) {
      state.user_id = userId;
    },

    SET_SIDE(state, side) {
      state.side = side;
    },

    SET_NAME(state, name) {
      state.name = name;
    },

    SET_POSITION(state, position) {
      state.position = position;
    },

    SET_AVATAR_URL(state, url) {
      state.avatar_url = url;
    },

    SET_EMAIL(state, email) {
      state.email = email;
    },

    SET_PHONE(state, phone) {
      state.phone = phone;
    },

    SET_FEED(state, payload) {
      state.feed = payload;
    },

    SET_AVATAR_COUNT_NOTIFY(state, payload) {
      state.count_notify = payload;
    },

    RESET_STATE(state) {
      Object.assign(state, resetState());
    },
  },

  actions: {
    init({ commit }, user) {
      commit("SET_USER_ID", user.user_id);
      commit("SET_SIDE", user.side);
      commit("SET_NAME", user.name);
      commit("SET_POSITION", user.position);
      commit("SET_EMAIL", user.email);
      commit("SET_PHONE", user.phone);
      commit("SET_AVATAR_URL", user.avatar?.thumb?.url);
      commit("SET_AVATAR_COUNT_NOTIFY", user?.unread_notifications_count);
      commit("SET_FEED", user.feed);
    },

    resetState({ commit, dispatch }) {
      dispatch("Settings/resetState");

      commit("RESET_STATE");
    },

    async getReadNotifyAll({ commit, rootGetters }) {
      try {
        const data = {
          user_id: rootGetters["User/getUserId"],
          org_id: rootGetters["Organizations/ActiveOne/getId"],
        };
        await UserService.fetchReadNotifyAll(data);
        commit("SET_AVATAR_COUNT_NOTIFY", 0);
      } catch (e) {
        console.error(e);
      }
    },

    async getReadNotify({ commit, rootGetters, state, dispatch }, notify_id) {
      try {
        const data = {
          user_id: rootGetters["User/getUserId"],
          org_id: rootGetters["Organizations/ActiveOne/getId"],
          notify_id,
        };

        await UserService.fetchReadNotify(data);
        commit("SET_AVATAR_COUNT_NOTIFY", state.count_notify - 1);
        dispatch("Notify/changeReadNotify", notify_id, { root: true });
      } catch (e) {
        console.error(e);
      }
    },
  },

  modules: {
    Settings,
  },
};
